<template>
  <div>
    <button type="button" class="link" @click="isOpen || open()">
      {{ poNumber }}
    </button>
    <PurchaseOrderModal
      v-if="purchaseOrder"
      :purchase-order="purchaseOrder"
      @hide-modal="close"
      @save-success="EventBus.$emit('refresh-datatable')"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useStore } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import PurchaseOrderModal from "@/Job/PurchaseOrderModal.vue";

const props = defineProps<{
  poNumber: string;
  poId: number;
  jobId: number;
}>();

const store = useStore();
const isOpen = ref(false);
const purchaseOrder = ref<Record<string, unknown> | null>(null);

// The modal reads the job from the store as it mounts, so it renders only
// once both requests are back.
async function open() {
  isOpen.value = true;
  try {
    const [, response] = await Promise.all([
      store.dispatch("fetchJob", { jobId: props.jobId }),
      store.dispatch("fetchPO", { id: props.poId, jobId: props.jobId })
    ]);
    purchaseOrder.value = response.data;
  } catch (error) {
    isOpen.value = false;
    throw error;
  }
}

function close() {
  isOpen.value = false;
  purchaseOrder.value = null;
}
</script>
